import { ClientCost, ServiceFeeType } from "api/models/ClientCost";
import { formatNumberWithTwoDecimals } from "helpers/numbers";

export const SERVICE_FEE_TYPE_LABELS: Record<ServiceFeeType, string> = {
  MONTHLY_FEE: "Fixed monthly fee",
  TRADED_VOLUME_FEE: "Traded volume (€/MWh)",
  FORECAST_VOLUME_FEE: "Forecast volume (€/MWh)",
  PRICE_PERCENTAGE_FEE: "Percentage of price (€)",
};

export const isServiceFeeType = (
  costType: ClientCost["costType"],
): costType is ServiceFeeType => costType in SERVICE_FEE_TYPE_LABELS;

const limitsDescription = (min: number | null, max: number | null) => {
  if (min === null && max === null) {
    return "";
  }
  const minPart =
    min === null ? "" : `min ${formatNumberWithTwoDecimals(min)} €`;
  const maxPart =
    max === null ? "" : `max ${formatNumberWithTwoDecimals(max)} €`;

  return ` (${[minPart, maxPart].filter(Boolean).join(", ")} per MTU)`;
};

export const serviceFeeDescription = (fee: ClientCost): string => {
  switch (fee.costType) {
    case "MONTHLY_FEE":
      return `${formatNumberWithTwoDecimals(fee.value ?? 0)} €/month`;
    case "TRADED_VOLUME_FEE":
    case "FORECAST_VOLUME_FEE":
      return `${formatNumberWithTwoDecimals(fee.value ?? 0)} €/MWh`;
    case "PRICE_PERCENTAGE_FEE":
      return [
        `Consumption ${formatNumberWithTwoDecimals(fee.consumptionPercent ?? 0)} %${limitsDescription(fee.consumptionMinEur, fee.consumptionMaxEur)}`,
        `production ${formatNumberWithTwoDecimals(fee.productionPercent ?? 0)} %${limitsDescription(fee.productionMinEur, fee.productionMaxEur)}`,
      ].join("; ");
    default:
      return "";
  }
};
